import { defaultAssignments, defaultRolesAndPermissions } from '@/configs/main';
import {
	getCurrentUser,
	getAssignments,
	getRolesAndPermissions,
} from '@/helpers/AuthHelper';
import {
	LOGIN_USER_EMBEDDED,
	LOGIN_LOCAL_USER,
	LOGIN_USER,
	LOGIN_USER_SUCCESS,
	LOGIN_USER_ERROR,
	LOGOUT_USER,
	RESET_PASSWORD,
	RESET_PASSWORD_SUCCESS,
	RESET_PASSWORD_ERROR,
	CHANGE_PASSWORD,
	CHANGE_PASSWORD_SUCCESS,
	CHANGE_PASSWORD_ERROR,
	BIND_MOBILE,
	BIND_MOBILE_SUCCESS,
	BIND_MOBILE_ERROR,
	CHANGE_ASSIGNMENTS,
	CHANGE_ROLES_PERMISSIONS,
	LOGIN_USER_SSO,
	LOGIN_USER_SSO2,
} from '../actions-registry';

const INIT_STATE = {
	currentUser: getCurrentUser(),
	assignments: getAssignments(),
	rolesAndPermissions: getRolesAndPermissions(),
	loading: false,
	error: '',
};

export default (state = INIT_STATE, action) => {
	switch (action.type) {
		case LOGIN_USER_EMBEDDED:
			return { ...state };
		case LOGIN_LOCAL_USER:
			return { ...state, loading: true, error: '' };
		case LOGIN_USER:
			return { ...state, loading: true, error: '' };
		case LOGIN_USER_SSO:
			return { ...state, loading: true, error: '' };
		case LOGIN_USER_SSO2:
			return { ...state, loading: true, error: '' };
		case LOGIN_USER_SUCCESS:
			return {
				...state,
				loading: false,
				currentUser: action.payload,
				error: '',
			};
		case LOGIN_USER_ERROR:
			return {
				...state,
				loading: false,
				currentUser: null,
				error: action.payload,
			};
		case LOGOUT_USER:
			return {
				...state,
				currentUser: null,
				assignments: defaultAssignments,
				rolesAndPermissions: defaultRolesAndPermissions,
				error: '',
			};
		case RESET_PASSWORD:
			return { ...state, loading: true, error: '' };
		case RESET_PASSWORD_SUCCESS:
			return {
				...state,
				loading: false,
				error: '',
			};
		case RESET_PASSWORD_ERROR:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		case CHANGE_PASSWORD:
			return { ...state, loading: true, error: '' };
		case CHANGE_PASSWORD_SUCCESS:
			if (action.payload) {
				return {
					...state,
					currentUser: {
						...state.currentUser,
						isTempPass: false,
						tempPass: null,
					},
					loading: false,
					error: '',
				};
			}
			return {
				...state,
				loading: false,
				error: '',
			};
		case CHANGE_PASSWORD_ERROR:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		case BIND_MOBILE:
			return { ...state, loading: true, error: '' };
		case BIND_MOBILE_SUCCESS:
			return {
				...state,
				currentUser: {
					...state.currentUser,
					phone: action.payload.mobile,
					phoneRegion: action.payload.region,
				},
				loading: false,
				error: '',
			};
		case BIND_MOBILE_ERROR:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		case CHANGE_ASSIGNMENTS:
			return {
				...state,
				assignments: action.payload,
			};
		case CHANGE_ROLES_PERMISSIONS:
			return {
				...state,
				rolesAndPermissions: action.payload,
			};
		default:
			return { ...state };
	}
};
